export default {
  CourseDetail_click_play: '0702Web - Click to play',
  CourseDetail_make_comment: '0707Web - Leave comment',
  CourseDetail_Like_others_comments: "0709Web - Like other's comment",
  CourseDetail_introduction_detail: 'Details:',
  CourseDetail_handleUp_introduction: 'Show less details',
  CourseDetail_starTip1: 'Very poor, one point is too much',
  CourseDetail_starTip2: 'Very poor, one point is too much',
  CourseDetail_starTip3: "Just so so, don't like it much",
  CourseDetail_starTip4: "Just so so, don't like it much",
  CourseDetail_starTip5: 'Not bad',
  CourseDetail_starTip6: 'Not bad',
  CourseDetail_starTip7: 'Good, rewarding',
  CourseDetail_starTip8: 'Good, rewarding',
  CourseDetail_starTip9: 'Very good, benefited a lot',
  CourseDetail_starTip10: 'Very good, benefited a lot',
  CourseDetail_resTime: '({resTime}sec)',
  CourseDetail_pass: 'Pass',
  CourseDetail_courseRule1: 'All the coursewares of this course has been learned',
  CourseDetail_courseRule2: 'Any courseware in the course has been learned',
  CourseDetail_examRule1: 'Required to take and pass all exams',
  CourseDetail_examRule2: 'Required to take all exams',
  CourseDetail_examRule3: 'Just take any exam',
  CourseDetail_examRule4: 'No exams required',
  CourseDetail_wearRule1: 'Pure audio/video courseware: Watch and listen to the full content',
  CourseDetail_wearRule2: 'Pure audio/video courseware: Watching or listening is considered to have learned',
  CourseDetail_wearRule3: 'Graphic and text / mixed / game coursewares: watched',
  CourseDetail_wearRule4: 'E-Books courseware: Read 100% content',
  CourseDetail_wearRule5: 'Graphic/hybrid/game courseware: learn for more than {value} minute(s)',
  CourseDetail_wearRuleTips: '(for the one with an exam, the exam should be passed)',
  CourseDetail_limitTime: 'Required to complete before {time}',
  CourseDetail_courseComRule: 'Course completion rules:',
  CourseDetail_wearComRule: 'The followings coursewares can be deem as learned if:',
  CourseDetail_examComRule: 'Conditions for having completed the exam:',
  CourseDetail_catalogue: 'Directory',
  CourseDetail_comRule: 'Completion rules',
}
